// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2-pUZ","tab":"Tabs_tab__2l0MJ","tabActive":"Tabs_tabActive__1Sbcl"};